import clsx from 'clsx'

type IProps = {
  title?: string
}
const Tooltip = ({ title }: IProps) => {
  return (
    <div
      className={clsx(
        'absolute hidden group-hover:flex items-center justify-center -translate-y-full -right-2/3 -top-1 px-4 py-2 bg-gray-600 rounded-lg text-white text-sm text-center',
      )}
    >
      {title}
    </div>
  )
}

export default Tooltip
